<template>
    <modal>
      <template v-slot:header>
        <h5 class="modal-title" id="exampleModalLabe_l" v-t="'recovery-password-title'"></h5>
        <button type="button" class="close" @click.prevent="$emit('close')">
          <span aria-hidden="true"><img src="@/assets/img/static/b-icon_close_x.svg" alt=""></span>
        </button>
      </template>

      <template v-slot:body>
        <template v-if="success">
          <div class="modal-body__registration">
            <p>{{$t('form.sign-up.caption.new-password-is-sent-to-email')}}</p>
          </div>
        </template>
        <template v-else-if="error">
          <div class="modal-body__registration">
            <p>{{error}}</p>
          </div>
        </template>
        <template v-else>
          <div class="modal-body__registration">
            <p v-t="'recovery-password-body'"></p>
          </div>
          <div class="a-form-field">
            <input type="text" class="a-input" :placeholder="$t('email-placeholder')" v-model="email">
            <span class="a-helper-text a-validation-error" v-if="$v.email.$dirty && !$v.email.required">{{$t('validation-error.mandatory-field')}}</span>
            <span class="a-helper-text a-validation-error" v-else-if="$v.email.$dirty && !$v.email.email">{{$t('validation-error.invalid-format')}}</span>
          </div>
        </template>
      </template>

      <template v-slot:footer>
        <template v-if="success">
          <button class="gui-btn gui-btn--white-border " type="button" data-dismiss="modal" @click="$emit('close')" v-t="'buttons.next'"></button>
        </template>
        <template v-else-if="error">
          <button class="gui-btn gui-btn--white-border " type="button" data-dismiss="modal" @click="$emit('close')" v-t="'buttons.next'"></button>
          <button class="gui-btn gui-btn--red " type="button" v-t="'recovery-btn'" @click="recoveryPassword"></button>
        </template>
        <template v-else>
          <button class="gui-btn gui-btn--white-border " type="button" data-dismiss="modal" @click="$emit('close')" v-t="'cancel-btn'"></button>
          <button class="gui-btn gui-btn--red " type="button" v-t="'recovery-btn'" @click="recoveryPassword"></button>
        </template>
      </template>
    </modal>
</template>

<script>
  import { required, email } from '@/validators'

  export default {
    name: "RecoveryPasswordModal",

    data: () => ({
      email: undefined,
      error: undefined,
      success: false
    }),

    validations: {
      email: {required, email}
    },

    methods: {
      async recoveryPassword() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('recoveryPassword', { email: this.email });
            this.success = true;
          }
          catch(e) {
            this.error = 'Что-то пошло не так'
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
